module.exports = __webpack_public_path__ + "static/img/sooka-launchprompt-cover.9b6a048.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/recent-works/sooka-launchprompt-cover.png
// module id = Ww87
// module chunks = 1